import { render } from "./AddrestaurantView.vue?vue&type=template&id=9bfd766c"
import script from "./AddrestaurantView.vue?vue&type=script&lang=js"
export * from "./AddrestaurantView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__